import type { I18nT } from '@runtime/core/i18n/i18n'
import { Button } from '@runtime/components/ui/Button'
import { FormField, FormLine } from '@runtime/components/ui/Form'
import { Modal, ModalTitle } from '@runtime/components/ui/Modal'
import styles from '@runtime/features/poster/components/PosterPrivatePrompt.module.scss'

type PosterPrivatePromptProps = {
  open: boolean
  t: I18nT
  privatePassword: string
  privateError: string
  onClose: () => void
  onPasswordChange: (value: string) => void
  onSubmit: () => void
}

export default function PosterPrivatePrompt({
  open,
  t,
  privatePassword,
  privateError,
  onClose,
  onPasswordChange,
  onSubmit,
}: PosterPrivatePromptProps) {
  return (
    <Modal open={open} lite onClose={onClose}>
      <ModalTitle>{t('posterModal.privateTitle')}</ModalTitle>
      <p className={styles.privatePromptText}>
        {t('posterModal.privatePrompt')}
      </p>
      <FormLine>
        <FormField
          type="password"
          value={privatePassword}
          onChange={(event) => onPasswordChange(event.currentTarget.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault()
              onSubmit()
            }
          }}
          placeholder={t('posterModal.privatePlaceholder')}
          autoFocus
        />
      </FormLine>
      {privateError ? (
        <p className={styles.privateError}>{privateError}</p>
      ) : null}
      <FormLine className={styles.actionsRow}>
        <Button variant="ghost" onClick={onClose}>
          {t('common.close')}
        </Button>
        <Button onClick={onSubmit}>{t('posterModal.privateConfirm')}</Button>
      </FormLine>
    </Modal>
  )
}
